<template>
    <div class="form">
        <h4 class="step-title">
            What kind of home is this?
        </h4>
        <div class="step-content d-flex flex-column align-items-center">
            <scrollable-button-list v-bind:items="homeTypes" v-bind:onclick="complete" v-bind:value="lead.homeInsurance.homeType"/>
        </div>
    </div>
</template>

<script>
    import ScrollableButtonList from "../shared/ScrollableButtonList.vue"

    export default {
        name: "HomeType",
        components: {
            ScrollableButtonList
        },
        data: function() {
            return {
                homeTypes: [
                    { text: "Apartment", value: "Apartment" },
                    { text: "Condo", value: "Condominium" },
                    { text: "Duplex", value: "Duplex" },
                    { text: "Mobile Home", value: "MobileHome" },
                    { text: "Multi Family", value: "MultiFamily" },
                    { text: "Single Family", value: "SingleFamily" },
                    { text: "Townhome", value: "Townhome" },
                    { text: "Other", value: "Other" }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
            complete: function(value) {
                this.lead.homeInsurance.homeType = value;
                this.$emit("complete", this.$options.name, value);
            }
        }
    }
</script>
